import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/reply-logo-min.svg'


const _hoisted_1 = { class: "main-dock on-desktop" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "reply-logo-min"
}, null, -1)

import { computed } from "vue";
import { useRouter } from "vue-router";
import ChatsIcon from "./icons/menu-icons/ChatsIcon.vue";
import ReplyIcon from "./icons/menu-icons/ReplyIcon.vue";
import MenuIcon from "./icons/menu-icons/MenuIcon.vue";
import DiagramIcon from "./icons/menu-icons/DiagramIcon.vue";
import LayoutIcon from "./icons/menu-icons/LayoutIcon.vue";
import { useTooltip } from "@/stores/tooltip";


export default /*#__PURE__*/_defineComponent({
  __name: 'TheMainDock',
  setup(__props) {

const links = [
  { to: "/comments-moderation/bms", match: "/comments-moderation", name: "Dashboard", icon: ChatsIcon },
  // { to: "/auto-replies/bms", match: "/auto-replies", name: "Auto-Replies", icon: ReplyIcon },
  // { to: "/blocklists", match: "/blocklists", name: "Blocklists", icon: MenuIcon },
  // { to: "/word-stats/bms", match: "/word-stats", name: "Word Stats", icon: DiagramIcon },
  { to: "/logs", match: "/logs", name: "Activity Logs", icon: LayoutIcon }
]

const router = useRouter()
const currentPath = computed(() => router.currentRoute.value.matched[1]?.path)
const { showTooltip } = useTooltip()


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "item reply-200-icon"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link) => {
      return _createVNode(_component_router_link, {
        to: link.to,
        class: _normalizeClass(["item", { active: _unref(currentPath).startsWith(link.match) }]),
        onMouseenter: ($event: any) => (_unref(showTooltip)($event, link.name))
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(link.icon)))
        ]),
        _: 2
      }, 1032, ["to", "class", "onMouseenter"])
    }), 64))
  ]))
}
}

})